import type { ProposePlaybookNodeToolOutput } from "@repo/app-types/entities/playbookConfigurationTools";
import {
  buildPlaybookProposalTool,
  buildProposalMeasurementDetail,
  buildProposalTitle,
} from "./playbookProposalTool.js";

/** "criteria" / "section", as the heading refers to the node. */
function describeNodeType(output: ProposePlaybookNodeToolOutput): string {
  return output.node_type === "criteria" ? "criteria" : "section";
}

export const ProposePlaybookNodeTool =
  buildPlaybookProposalTool<ProposePlaybookNodeToolOutput>({
    running: "Preparing a playbook change",
    failed: "preparing the playbook change",
    proposalTitle: (output) => {
      const nodeType = describeNodeType(output);
      if (output.action === "delete") {
        return `Proposed removing ${nodeType} "${output.node_name}"`;
      }
      return buildProposalTitle(
        output.action === "create"
          ? `Proposed new ${nodeType}`
          : `Proposed ${nodeType} update`,
        output.node_name,
      );
    },
    // A delete runs no sample, so it has nothing to report having measured.
    detail: (output) =>
      output.action === "delete"
        ? undefined
        : buildProposalMeasurementDetail(output.sample_size),
  });
